import React from 'react';
import type { Editor } from '@tiptap/core';
import { usePopupSuggestionRender } from '../RichTextDescription/useSlashCommand';
import type { CommentMentionSuggestionOptions } from './extensions/commentMentionSuggestion';
import { buildCommentMentionItems } from './utils/commentMentionItems';
import type { User } from '../RichTextDescription/types';

export function useCommentMentionSuggestion(
  mentionableUsers: User[],
  popupContainerRef: React.RefObject<HTMLDivElement | null>
): Pick<CommentMentionSuggestionOptions, 'items' | 'render' | 'hasMentionableUsers'> {
  const usersRef = React.useRef(mentionableUsers);
  usersRef.current = mentionableUsers;

  const items = React.useCallback(
    ({ query }: { query: string; editor: Editor }) => buildCommentMentionItems(usersRef.current, query),
    []
  );
  const hasMentionableUsers = React.useCallback(() => usersRef.current.length > 0, []);
  const render = usePopupSuggestionRender(popupContainerRef);

  return { items, render, hasMentionableUsers };
}
